export default {
    name: 'DateInput',
    filter(field, filterForm, options) {
        return {
            input: 'oc-date-input',
            options: {
                inputAttrs: {
                    autocomplete: 'off'
                },
                inputPrepend: {
                    component: 'oc-icon',
                    attrs: {
                        type: 'calendar'
                    }
                }
            }
        }
    }
}
